import { EChannel } from 'core/model/enums/channel.enum';
import { ImageRoutes } from './image-routes';

interface IChannelTheme {
  name: string;
  logo: string;
  logoAlt: string;
  profileBanner: string;
  title: string;
  logoFooter: string;
  maintenanceImage: string;
}

export const CHANNEL_THEMES: Record<EChannel, IChannelTheme> = {
  [EChannel.DIADIA]: {
    name: 'diadia',
    logo: ImageRoutes.LOGO_MAIN_HEADER_DIADIA,
    logoAlt: 'Logo Diadía',
    logoFooter: ImageRoutes.LOGO_FOOTER_DIADIA,
    profileBanner: ImageRoutes.PROFILE_BANNER_DIADIA,
    title: 'Diadía',
    maintenanceImage: ImageRoutes.MAINTENANCE_DIADIA,
  },
  [EChannel.INSUMA]: {
    name: 'insuma',
    logo: ImageRoutes.LOGO_MAIN_HEADER_INSUMA,
    logoAlt: 'Logo Insuma',
    logoFooter: ImageRoutes.LOGO_FOOTER_INSUMA,
    profileBanner: ImageRoutes.PROFILE_BANNER_INSUMA,
    title: 'Insuma',
    maintenanceImage: ImageRoutes.MAINTENANCE_INSUMA,
  },
  [EChannel.ALICORP]: {
    name: 'alicorp',
    logo: ImageRoutes.LOGO_MAIN_HEADER_INSUMA,
    logoAlt: 'Logo Alicorp',
    logoFooter: ImageRoutes.LOGO_MAIN_HEADER_INSUMA,
    profileBanner: ImageRoutes.LOGO_MAIN_HEADER_INSUMA,
    title: 'Alicorp',
    maintenanceImage: ImageRoutes.MAINTENANCE_INSUMA,
  },
};

export const CHANNEL_FAVICONS: Record<EChannel, string> = {
  [EChannel.DIADIA]: '/favicon-diadia.ico',
  [EChannel.INSUMA]: '/favicon-insuma.ico',
  [EChannel.ALICORP]: '/favicon.ico',
};
